<template>
	<LayoutForm>
		<h1 slot="header">Create Intelligence</h1>

		<form class="form" @submit.prevent="submit" novalidate>
			<ValidationAlert :error-list="errors.collect('server')"></ValidationAlert>

			<fieldset class="form__group">
				<FormControlSector name="sectors" v-model="formData.sectors" v-validate="'required'" :multiple="true">
				</FormControlSector>

				<div class="form__group">
					<textarea id="intel-content" name="content" class="form__control"
					          v-model="formData.content"
					          placeholder="Enter your intel here..." v-validate required></textarea>
					<label for="intel-content" class="form__label">Add your Intel</label>
					<div class="form__validation">{{ errors.first('content') }}</div>
				</div>

				<FormControlDealType v-model="formData.dealType" name="dealType" v-validate="'required'">
				</FormControlDealType>

				<div class="form__group form__group--submit">
					<router-link to="/intelligence" class="btn">Cancel</router-link>
					<button class="btn btn--primary">Save &amp; Preview</button>
				</div>
			</fieldset>
		</form>
	</LayoutForm>
</template>

<script>
	import API from '../../api';
	import LayoutForm from '../Layout/LayoutForm';
	import FormControlSector from '../Form/Control/FormControlSector';
	import FormControlDealType from '../Form/Control/FormControlDealType';
	import ValidationAlert from '../ValidationAlert';
	import Form from '../Form/Form';

	export default {
		name: 'IntelligenceForm',
		mixins: [Form],
		components: {
			ValidationAlert,
			FormControlDealType,
			FormControlSector,
			LayoutForm,
		},
		data() {
			return {
				formData: {
					sectors: [],
					content: null,
					dealType: null,
				},
			}
		},
		methods: {
			fetchResource(id) {
				return API.getIntelligence(id);
			},
			sanitizeResource(data) {
				if(Array.isArray(data.sectors)) {
					data.sectors = data.sectors.map(sector => {
						return sector.id;
					});
				}

				data.dealType = data.dealTypeId;

				return data;
			},
			submit() {
				this.$validator.validateAll().then((result) => {
					if(!result) {
						return;
					}

					let req = (this.id)
						? API.updateIntelligence(this.id, this.formData)
						: API.createIntelligence(this.formData);

                    const eventCategory = this.id ? "update" : "create";
                    if(window.gtag) {
                        console.log("Submitting Intelligence submit event with category: ", eventCategory)

                        window.gtag("event", "form_submission", {
                            "event_category": eventCategory,
                            "event_label": "intelligence"
                        });
                    }

					req.then(response => {
						this.$router.push({
							name: 'intelligence-preview',
							params: { intelligence_id: response.id },
						});
					})
						.catch(error => {
							API.mapServerValidation(error.response, this.$validator);
						});
				});
			},
		},
	}
</script>
